export default __webpack_public_path__ + "static/media/linode-negative.9c798337.svg";